/* Taabaan v3 (Clozee style), 11 Oct 2026: hero slider, swipe rows (arrows + dots), quantity pill and the
   "Order now" button (adds the chosen variant + quantity to the bag, then opens checkout). */
(function () {
  'use strict';

  function initHero(root) {
    if (root.dataset.tbReady) return; root.dataset.tbReady = '1';
    var slides = [].slice.call(root.querySelectorAll('[data-tb-slide]'));
    var bars = [].slice.call(root.querySelectorAll('[data-tb-bar]'));
    if (slides.length < 2) return;
    var speed = (parseInt(root.dataset.speed, 10) || 5) * 1000, i = 0, timer = null;
    root.style.setProperty('--tb-speed', speed + 'ms');
    function restart() { clearTimeout(timer); timer = setTimeout(function () { go(i + 1); }, speed); }
    function go(n) {
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      bars.forEach(function (b, k) { b.classList.remove('is-active'); b.classList.toggle('is-done', k < i); });
      if (bars[i]) { void bars[i].offsetWidth; bars[i].classList.add('is-active'); }
      restart();
    }
    bars.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1));
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else restart(); });
    restart();
  }

  function initCarousel(root) {
    if (root.dataset.tbReady) return; root.dataset.tbReady = '1';
    var track = root.querySelector('[data-tb-track]');
    if (!track) return;
    var prev = root.querySelector('[data-tb-prev]'), next = root.querySelector('[data-tb-next]');
    var dots = root.querySelector('[data-tb-dots]');
    function step() {
      var item = track.children[0];
      if (!item) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    function edges() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.classList.toggle('is-off', track.scrollLeft <= 2);
      if (next) next.classList.toggle('is-off', track.scrollLeft >= max);
    }
    if (dots) {
      dots.innerHTML = '';
      for (var k = 0; k < track.children.length; k++) {
        (function (k) {
          var b = document.createElement('button');
          b.type = 'button'; b.setAttribute('aria-label', 'Go to ' + (k + 1));
          b.addEventListener('click', function () { track.children[k].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); });
          dots.appendChild(b);
        })(k);
      }
    }
    function update() {
      edges();
      if (!dots) return;
      var mid = track.getBoundingClientRect().left + track.clientWidth / 2, best = 0, bestD = 1e9;
      for (var k = 0; k < track.children.length; k++) {
        var r = track.children[k].getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bestD) { bestD = d; best = k; }
      }
      [].forEach.call(dots.children, function (d, j) { d.classList.toggle('is-active', j === best); });
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-tb-hero]'), initHero);
    [].forEach.call((scope || document).querySelectorAll('[data-tb-carousel]'), initCarousel);
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest && e.target.closest('[data-tb-step]');
    if (step) {
      var input = step.parentElement.querySelector('input');
      var v = Math.min(20, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.tbStep, 10)));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-tb-order-now]');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form');
    var add = form && form.querySelector('[name="add"]');
    if (!form || btn.disabled || (add && (add.disabled || add.getAttribute('aria-disabled') === 'true'))) return;
    var pf = btn.closest('product-form');
    var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    var msg = pf && pf.querySelector('.product-form__error-message');
    btn.classList.add('is-loading'); btn.disabled = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); })
      .then(function () { window.location.href = root + 'checkout'; })
      .catch(function (err) {
        btn.classList.remove('is-loading'); btn.disabled = false;
        if (wrap && msg) { msg.textContent = err.message; wrap.hidden = false; }
      });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
